import React, { memo, useState } from 'react'
import { DoneButton } from 'components/blue-button'
import DismissButton from 'components/dismiss-button'
import UploadBox from 'components/upload-box'
import { useUploadFilesMutation } from 'util/rtk-api'
// Removed Question dependency to allow flexible upload targets
import styles from 'css/components/lesson-builder/add-image-overlay.module.css'

export const AddImageOverlay = memo((
    { setShowAddImageOverlay, onUpload, title = 'Add Image', note = '', optionText = '' }: { setShowAddImageOverlay: (showAddImageOverlay: boolean) => void, onUpload: (url: string) => void, title?: string, note?: string, optionText?: string }) => {

    const [pendingUrl, setPendingUrl] = useState<string | null>(null)
    const [uploadFiles] = useUploadFilesMutation()

    const handleFileUpload = async (file: File) => {
        const data = await uploadFiles([file]).unwrap()
        setPendingUrl(data.urls[0])
    }

    return (
        <div className="overlay">
            <div className="overlay-content-container">
                <div className="overlay-content-header">
                    <h3>{title}</h3>
                    <DismissButton onClick={() => setShowAddImageOverlay(false)} />
                </div>
                <div className="overlay-content-body" style={{ paddingTop: '1rem' }}>
                    <div className="upload-box-row">
                        <UploadBox
                            name="Image"
                            acceptedFileTypes={['image/*']}
                            acceptedFileExtensionsText=".PNG, .JPEG, .JPG"
                            onFileUpload={(file) => handleFileUpload(file)}
                        />
                    </div>
                    <div className="alignRight">
                        <DoneButton onClick={() => {
                            if (pendingUrl) {
                                onUpload(pendingUrl)
                            }
                            setShowAddImageOverlay(false)
                        }} />
                    </div>
                </div>
            </div>
        </div>
    )
})

export default AddImageOverlay


